import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Card } from "../../components/Card";
import { SectionTitle } from "../../components/SectionTitle";
import { InfoBox } from "../../components/InfoBox";
import { spacing } from "@styling/sizing";
import { StoreInfoEditForm } from "../components/StoreInfoEditForm";

const Section = styled(Card)`
  max-width: 820px;
  display: flex;
  flex-direction: column;
  gap: ${spacing.x2}px;
`;

export const GeneralSettingsView = () => {
  const { t } = useTranslation();
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  useEffect(() => {
    if (!successMessage) {
      return;
    }
    const timer = setTimeout(() => setSuccessMessage(null), 3000);
    return () => clearTimeout(timer);
  }, [successMessage]);

  return (
    <Section as="section" aria-labelledby="store-info-title">
      <SectionTitle id="store-info-title">
        {t("storeSettings.storeInfo")}
      </SectionTitle>
      {successMessage && <InfoBox variant="success">{successMessage}</InfoBox>}
      <StoreInfoEditForm onSuccess={setSuccessMessage} />
    </Section>
  );
};
